/**
 * Imandra Universe pricing tiers.
 *
 * Source of truth for pricing data shared across all Imandra products
 * (codelogician.dev, imandrax.dev, speclogician.dev, etc.).
 * Keep aligned with imandra-web marketing and universe.imandra.ai/#pricing.
 *
 * The type is intentionally open-ended so each consumer can extend it
 * with presentation-only fields without modifying this file.
 */

export type PricingTier = {
  name: string
  description: string
  price: string
  priceNote: string
  mostPopular: boolean
  trialNote?: string
}

export const imandraUniverseTiers: PricingTier[] = [
  {
    name: 'Builder',
    description: 'Built for individual builders who need predictable usage.',
    price: '$25',
    priceNote: '/month',
    mostPopular: true,
    trialNote: '7 days free',
  },
  {
    name: 'Pro',
    description: 'For advanced users running heavier reasoning workloads.',
    price: '$129',
    priceNote: '/month',
    mostPopular: false,
  },
  {
    name: 'Team',
    description:
      'Collaboration and scale for teams shipping reasoning systems.',
    price: '$799',
    priceNote: '/month',
    mostPopular: false,
  },
]
